type InfoCircleStrokeIconProps = {
  size?: number;
  color?: string;
};

const InfoCircleStrokeIcon = ({
  size = 18,
  color = '#015b78',
}: InfoCircleStrokeIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="9" cy="9" r="7.5" stroke={color} strokeWidth="1.5" />
    <path d="M9 8.25V13" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="9" cy="5.75" r="0.875" fill={color} />
  </svg>
);

export default InfoCircleStrokeIcon;
